import { css } from '@emotion/css';

export const styWrapper = css`
  margin: 16px 0;
  background: #CEEBFF;
  padding: 4px 8px;
  border-radius: 8px;
`

export const styMessageBox = ({ isCenter }) => css`
  margin: 16px 0 0;
  width: 100%;
  display: flex;
  flex-flow: column;

  ${isCenter && 
  `
    align-items: center;
  `}

  > div {
    padding: 8px;
    ${isCenter && 
    `
      width: 50%;
    `}
    
    > div > span {
      margin-right: 2px !important;
    }

      > div > div {
      width: 100%;

      > span {
        margin-bottom: 0px !important;
      }
    }
  }
`

export const styTitleWrapper = ({ withAction }) => css`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  ${withAction && 
  `
    cursor: pointer;
  `}
`

export const styTitleInfo = css`
  display: flex;
  flex-flow: row wrap;
`

export const styAmount = css`
  font-weight: bold;
  margin-right: 8px;
`

export const styAction = css`
  display: flex;
  align-self: center;
`

